var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"echarts",staticStyle:{"width":"100%"},style:({height:(_vm.type=='bar'?'85%':'100%')}),attrs:{"id":_vm.id}})}
var staticRenderFns = []

export { render, staticRenderFns }